import { render, staticRenderFns } from "./icon-bookmark.vue?vue&type=template&id=30441bac"
import script from "./icon-bookmark.vue?vue&type=script&lang=ts"
export * from "./icon-bookmark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports